import { joinSurveyAction } from '../join-survey';
import type { ConnectChannel } from '../types';

/**
 * Static content for the Gen AI LLM: ChatGPT channel detail page
 * (`/connect/gen-ai-chatgpt`). Same sourcing rule as demographics.ts:
 * copied, not imported, since the source (Data Catalog / EXPLORE_CHANNELS)
 * backs internal-only tooling and this page is visible to every Home user.
 */
export const GEN_AI_CHATGPT_CHANNEL: ConnectChannel = {
    name: 'ChatGPT',
    icon: 'sparkles',
    color: '#418363',
    subtitle: 'US · 394,778 conversations',
    subtitleLine2: 'Daily · Since 2023',
    exploreDaniPrompt: 'What can ChatGPT conversation data tell me about my consumers?',
    actions: [
        {
            id: 'chatgpt-intent',
            name: 'Mine intent',
            icon: 'message-circle',
            summary: 'what shoppers ask ChatGPT about your category',
            template:
                'What have shoppers asked ChatGPT about {category|my category} in {window|the last 12 weeks}?',
        },
        {
            id: 'chatgpt-rank',
            name: 'Rank brands',
            icon: 'briefcase',
            summary: 'how your brand ranks against competitors when people ask ChatGPT',
            template:
                'How does {brand|my brand} rank against {competitors|competitors} in ChatGPT responses about {category|my category}?',
        },
        {
            id: 'chatgpt-mentions',
            name: 'Track mentions',
            icon: 'trending-up',
            summary: 'how often your brand comes up in ChatGPT conversations, and the trend',
            template:
                'Track how often {brand|my brand} is mentioned in ChatGPT conversations over {window|the last 12 weeks}',
        },
        joinSurveyAction('gen-ai-chatgpt'),
    ],
    schema: [
        { field: 'consumer_id', type: 'string', description: 'Pseudonymous panel ID' },
        { field: 'conversation_id', type: 'string', description: 'Conversation thread ID' },
        { field: 'conversation_title', type: 'string', description: 'Auto-titled by ChatGPT' },
        { field: 'message_text', type: 'text', description: 'Verbatim user message' },
        { field: 'content_type', type: 'string', description: 'text / multimodal_text / image' },
        { field: 'sent_at', type: 'timestamp', description: 'Message send time' },
    ],
    sampleCols: ['Conversation', 'Message', 'Type', 'Date'],
    sampleColWidths: ['minmax(140px, 1.5fr)', 'minmax(220px, 3fr)', 'minmax(90px, 1fr)', '90px'],
    sampleRows: [
        [
            'Turkey Hunting Setup Tips',
            '"Should decoy be in field or woods with me"',
            'text',
            '2026-04-24',
        ],
        [
            'Turkey Hunting Setup Tips',
            '"Morning. I\'ll be in a small pop up blind..."',
            'text',
            '2026-04-24',
        ],
        [
            'Turkey Hunting Setup Tips',
            '"Blue dot is where I\'m set up..."',
            'multimodal_text',
            '2026-04-24',
        ],
        ['Quick Phone Income Ideas', '"Fast cash"', 'text', '2026-04-24'],
        [
            'Quick Phone Income Ideas',
            '"Hey, what\'s some quick ways I can make extra income from my phone?"',
            'text',
            '2026-04-24',
        ],
    ],
};
